import { DateTime } from "luxon"
import * as util from "./util"
import * as utillogin from "./utillogin"
import Swal from "sweetalert2"

export async function openSessionSlideOver(session_id, session) {
  let cancelButton = document.getElementById("cancel-button")
  let confirmButton = document.getElementById("confirm-button")
  let editButton = document.getElementById("edit-button")
  confirmButton.classList.add("hide")
  cancelButton.classList.add("hide")
  cancelButton.innerText = "Cancel booking"
  editButton.classList.add("hide")
  let onsiteContactSection = document.getElementById("onsite-contact-section")
  onsiteContactSection.classList.add("hide")
  let addressSection = document.getElementById("address-section")
  addressSection.classList.add("hide")
  // Delete previously added addons
  let addonContainer = document.getElementById("addon-container")
  addonContainer.querySelectorAll(".price-element").forEach((e) => e.remove())
  // Delete previously added questions
  let questionsContainer = document.getElementById("questions")
  questionsContainer
    .querySelectorAll(".question-component")
    .forEach((e) => e.remove())
  document.getElementById("addon-container").classList.add("hide")
  document.getElementById("discount-section").classList.add("hide")
  document.getElementById("subtotal-section").classList.add("hide")
  document.getElementById("spinner-background").classList.remove("hide")
  document.getElementById("slide-over-container").classList.remove("hide")
  document.getElementById("slide-over-container").classList.add("show")
  document.getElementById("booker-all-sessions").classList.remove("hide")
  document.getElementById("booker-all-sessions-dot").classList.remove("hide")
  // Reset the space booking link section
  document.getElementById("space-booking-link-section").classList.add("hide")
  document.getElementById("copy-space-booking-link").classList.remove("hide")
  document.getElementById("space-booking-link-copied").classList.add("hide")
  document.getElementById("payment-section").classList.add("hide")
  document.getElementById("changes-payment-section").classList.add("hide")
  document.getElementById("payment-title").innerText = "Booker payment"
  document
    .getElementById("space-booking-link-explainer")
    .classList.remove("hide")
  document.getElementById("earnings-section").classList.add("hide")

  let isAdmin = await utillogin.getClerkUserIsAdmin()
  if (session) {
    // In /bookings we will already have some session data so do initial
    // updates using that
    sessionSlideOverUpdates(session, session, isAdmin)
  }

  let token = await utillogin.getClerkToken()
  let sessionData
  try {
    sessionData = await util.api
      .get(
        `get-session-detail?token=${token}&session_id=${session_id}&include_accounting=true`
      )
      .json()
  } catch (error) {
    util.logToSentry(error)
    util.logAmplitudeEvent("Unknown Error Retrieving Session Detail")
    Swal.fire({
      icon: "error",
      text: "There was an error getting the detail for this session. Try again and if this problem persists please email venuesupport@sharesy.com",
      confirmButtonText: "OK",
      confirmButtonColor: "#d31818",
      customClass: {
        popup: "swal-custom-popup",
        title: "swal-custom-title",
        confirmButton: "swal-custom-button",
      },
    })
    closeSessionSlideOver()
  }
  if (!session) {
    sessionSlideOverUpdates(sessionData, sessionData.booking, isAdmin)
  }
  editButton.href =
    window.location.origin +
    "/change-session?id=" +
    sessionData.encrypted_trans_id_str
  if (
    !sessionData.confirmed &&
    sessionData.status_code != "cancelled" &&
    sessionData.encrypted_trans_id_venue_str
  ) {
    confirmButton.href =
      window.location.origin +
      "/dashboard-host-confirm?id=" +
      sessionData.encrypted_trans_id_venue_str
    confirmButton.classList.remove("hide")
  }
  /* Allow recurring bookings to be cancelled by venues.
     Other bookings need to be declined. */
  if (
    sessionData.status_code != "cancelled" &&
    (isAdmin ||
      sessionData.booking.source == "Recurring booking" ||
      (sessionData.booking.source == "Dashboard" &&
        sessionData.booking.multi_session_booking))
  ) {
    cancelButton.href = "#"
    cancelButton.target = "_self"
    cancelButton.classList.remove("hide")
    cancelButton.dataset.cancelBy = sessionData.cancel_by
  } else if (
    !sessionData.cancelled &&
    sessionData.encrypted_trans_id_venue_str
  ) {
    cancelButton.href =
      "https://www.sharesy.com/venue-decline?id=" +
      sessionData.encrypted_trans_id_venue_str
    cancelButton.target = "_blank"
    cancelButton.innerText = "Decline"
    cancelButton.classList.remove("hide")
  }
  // We could enable the edit button earlier, but wait to unhide all the
  // buttons together, to avoid e.g. a user clicking Confirm by mistake
  // because it appears where Edit was, or they want to Confirm but click
  // Edit because that is the only option they see.
  if (
    sessionData.status_code != "cancelled" &&
    sessionData.encrypted_trans_id_str // this will be missing if session doesn't load to Datastore
  ) {
    editButton.classList.remove("hide")
    if (isAdmin) {
      editButton.innerText = "Reschedule" // So the buttons fit on one line
    }
  }
  if (sessionData.onsite_number_text) {
    document.getElementById("onsite-contact").innerText =
      sessionData.onsite_number_text
    document.getElementById(
      "onsite-contact-link"
    ).href = `https://www.sharesy.com/dashboard-onsite-contact?id=${sessionData.encrypted_trans_id_venue_str}`
    onsiteContactSection.classList.remove("hide")
  }
  if (sessionData.booking.address) {
    document.getElementById("address").innerText = sessionData.booking.address
  } else {
    document.getElementById("address").innerText = "Address not provided"
  }
  addressSection.classList.remove("hide")
  if (sessionData.addons.length > 0) {
    sessionData.addons.forEach((addon) => {
      let addonDiv = document.createElement("div")
      addonDiv.classList.add("price-element")
      let addonNameDiv = document.createElement("div")
      addonNameDiv.innerText = addon.name
      addonDiv.appendChild(addonNameDiv)
      let addonPriceDiv = document.createElement("div")
      addonPriceDiv.innerText = "£" + parseFloat(addon.total_price).toFixed(2)
      addonDiv.appendChild(addonPriceDiv)
      addonContainer.appendChild(addonDiv)
    })
    document.getElementById("addon-container").classList.remove("hide")
  }
  if (sessionData.discount > 0) {
    document.getElementById("promo").innerText =
      "Promo (" + sessionData.booking.promo_code + ")"
    document.getElementById("discount").innerText = "-£" + sessionData.discount
    document.getElementById("discount-section").classList.remove("hide")
    if (sessionData.addons.length > 0) {
      // Only display subtotal when there are addons and a promo code
      document.getElementById("subtotal").innerText =
        "£" + sessionData.total_original
      document.getElementById("subtotal-section").classList.remove("hide")
    }
  }

  updateBookerPaymentSection(sessionData, isAdmin)

  sessionData.booking.questions.forEach((question) => {
    let questionComponent = document.createElement("div")
    questionComponent.classList.add("question-component")
    let questionTextDiv = document.createElement("div")
    questionTextDiv.classList.add("text-10px-upper")
    questionTextDiv.innerText = question.question
    questionComponent.appendChild(questionTextDiv)
    let answerDiv = document.createElement("div")
    answerDiv.innerText = question.answer
    questionComponent.appendChild(answerDiv)
    questionsContainer.appendChild(questionComponent)
  })

  if (sessionData.accounting?.standard_accounting?.venue_total) {
    let bookingFee =
      "£" + sessionData.accounting.standard_accounting.sharesy_fee
    // If there is a booking fee then show it as e.g. "-£2.00"
    if (sessionData.accounting.standard_accounting.sharesy_fee > 0) {
      bookingFee = "-" + bookingFee
    }
    document.getElementById("booking-fee").innerText = bookingFee

    let sharesyCommission =
      "£" + sessionData.accounting.standard_accounting.sharesy_commission
    if (sessionData.accounting.standard_accounting.sharesy_commission > 0) {
      sharesyCommission = "-" + sharesyCommission
    }
    document.getElementById("commission").innerText = sharesyCommission

    let commissionText = "Sharesy commission ("
    if (
      sessionData.accounting.standard_accounting.commission_percent_ex_vat ===
        "16.00" ||
      sessionData.accounting.standard_accounting.commission_percent_ex_vat ===
        "8.00"
    ) {
      // For bookings made using the new 16% or 8% pricing, show ex VAT
      commissionText +=
        util.roundToMaxDp(
          sessionData.accounting.standard_accounting.commission_percent_ex_vat,
          2
        ) + "% + VAT"
    } else {
      commissionText +=
        util.roundToMaxDp(
          sessionData.accounting.standard_accounting.commission_percent_inc_vat,
          2
        ) + "% incl. VAT"
    }
    commissionText += ")"
    document.getElementById("commission-text").innerText = commissionText

    let adjustmentContainer = document.getElementById("adjustment-container")
    adjustmentContainer.innerHTML = ""
    sessionData.accounting.adjustments.forEach((adjustment) => {
      let adjustmentDiv = document.createElement("div")
      adjustmentDiv.classList.add("price-element")
      let adjustmentTextDiv = document.createElement("div")
      adjustmentTextDiv.innerText = adjustment.venue_note
      adjustmentDiv.appendChild(adjustmentTextDiv)
      let adjustmentPriceDiv = document.createElement("div")
      if (parseFloat(adjustment.venue_total) > 0) {
        adjustmentPriceDiv.innerText = "£" + adjustment.venue_total
      } else {
        adjustmentPriceDiv.innerText =
          "-£" + Math.abs(parseFloat(adjustment.venue_total)).toFixed(2)
      }
      adjustmentPriceDiv.classList.add("nowrap")
      adjustmentDiv.appendChild(adjustmentPriceDiv)
      adjustmentContainer.appendChild(adjustmentDiv)
      adjustmentContainer.classList.remove("hide")
    })

    document.getElementById("total-payout").innerText =
      "£" + sessionData.accounting.venue_total
    let totalPayoutHTML = "Total payout"
    if (!sessionData.cancelled) {
      let earningsUrl = new URL("https://www.sharesy.com/earnings")
      let searchParams = new URLSearchParams(earningsUrl.search)
      searchParams.set("venueid", sessionData.venue_id)
      if (sessionData.accounting.payout_dates.length === 1) {
        searchParams.set("payoutdate", sessionData.accounting.payout_dates[0])
      }
      earningsUrl.search = searchParams
      totalPayoutHTML += ` (<a target="_blank" href=${earningsUrl.href}>${sessionData.accounting.payout_description}</a>)`
    }
    document.getElementById("total-payout-text").innerHTML = totalPayoutHTML

    document.getElementById("earnings-section").classList.remove("hide")
  }
  // Show the payout adjustment link to admins whether or not there is accounting data
  // (e.g. if commission is missing, we need the link to appear so we can add an
  // adjustment)
  document.getElementById("payout-adjustment-link").href =
    "https://sharesy.retool.com/apps/8e30700e-9839-11ef-8b21-b3b3f3107640/Payout%20adjustments#session=" +
    sessionData.session_id
  if (isAdmin) {
    document.getElementById("payout-adjustment-link").classList.remove("hide")
  }

  // If we have pricing rules for this booker's email then display a booking link for them
  if (
    sessionData.booking.booker_has_pricing &&
    sessionData.booking.encrypted_email
  ) {
    document.getElementById(
      "copy-space-booking-link"
    ).dataset.spaceBookingUrl = `${window.location.origin}/s/${sessionData.space_slug}?booker=${sessionData.booking.encrypted_email}`
    document
      .getElementById("space-booking-link-section")
      .classList.remove("hide")
  }

  document.getElementById("spinner-background").classList.add("hide")
}

/* Set the data to display in the 'Booker payment' section.
 * For example:
      £148.00 *overdue* on invoice _97464653-4857_ (5 sessions, total
      £740.00). Due 07 Jan 2025.
      _View in Stripe_
*/
function updateBookerPaymentSection(session, isAdmin) {
  let paymentStatus = ""
  let paidDate = ""
  let invoiceText = "."
  let paymentAmount = null
  if (
    ["alternate_card", "default_card"].includes(
      session.booking.payment_method_code
    )
  ) {
    // Mark as paid if the booker paid via card at time of booking
    paymentStatus = "Paid"
    // We only know the paidDate when it is paid at time of booking (either from an
    // invoice or a Stripe Checkout payment intent). If an invoice is issued and it is
    // paid later, we don't currently store the paid date.
    let purchaseDateTime = DateTime.fromISO(
      session.booking.purchase_utc
    ).setZone(util.TIMEZONE)
    paidDate = ` on ${purchaseDateTime.toFormat("dd LLL yyyy")}`

    // Don't set the paymentAmount here since we aren't sure what it is (we can't just
    // take the current price because it may have been changed since).
  } else if (
    session.booking.invoice &&
    (session.status_code != "cancelled" ||
      session.booking.invoice.status === "paid")
  ) {
    if (session.booking.invoice.status === "overdue") {
      paymentStatus = `<strong>overdue</strong>`
    } else if (session.booking.invoice.status == "open") {
      paymentStatus = "owed"
    } else if (session.booking.invoice.status == "paid") {
      paymentStatus = "paid"
    }
  }

  if (
    session.booking.invoice &&
    (session.status_code != "cancelled" ||
      session.booking.invoice.status === "paid")
  ) {
    if (session.booking.invoice.hosted_invoice_url) {
      invoiceText = ` on invoice <a href="${session.booking.invoice.hosted_invoice_url}" target="blank">${session.booking.invoice.invoice_num}</a>`
    } else {
      invoiceText = ` on invoice ${session.booking.invoice.invoice_num}`
    }
    // If the invoice includes multiple sessions, we display the amount due just for
    // this session, but show the total amount and number of sessions in brackets.
    if (
      session.booking.multi_session_booking &&
      parseFloat(session.booking.invoice.total) >
        parseFloat(session.total_price)
    ) {
      invoiceText += ` (invoice includes ${session.booking.uncancelled_session_count} sessions, total £${session.booking.invoice.amount_due})`
    }
    invoiceText += "."
    // This text is only added when the invoice is unpaid
    if (["open", "overdue"].includes(session.booking.invoice.status)) {
      if (session.booking.invoice.due_date) {
        let dueDate = DateTime.fromISO(
          session.booking.invoice.due_date
        ).setZone(util.TIMEZONE)
        invoiceText += ` Due ${dueDate.toFormat("dd LLL yyyy")}.`
      }
      if (session.booking.invoice.bacs_debit_status) {
        // If the direct debit is inactive or invalid somehow bacs_debit_status is null
        if (
          ["pending", "processing"].includes(
            session.booking.invoice.bacs_debit_status
          )
        ) {
          invoiceText += `<br/>The booker has set up a direct debit, awaiting approval from their bank. If it is approved payment will be attempted within 6 working days.`
        } else if (session.booking.invoice.bacs_debit_status === "active") {
          invoiceText += `<br/>The booker has set up a direct debit which their bank approved, payment will be attempted within 3 working days.`
        }
      } else if (session.booking.invoice.last_payment_error_message) {
        invoiceText += `<br/>The last payment attempt`
        if (session.booking.invoice.last_payment_error_card_brand) {
          invoiceText += ` with ${session.booking.invoice.last_payment_error_card_brand} ending ${session.booking.invoice.last_payment_error_card_last4}`
        } else if (
          session.booking.invoice.last_payment_error_bacs_debit_last4
        ) {
          invoiceText += ` via direct debit on account ending ${session.booking.invoice.last_payment_error_bacs_debit_last4}`
        }
        invoiceText += ` failed: <em>${session.booking.invoice.last_payment_error_message}</em>`
      }
    }
    if (session.booking.uncancelled_session_total_price > 0) {
      paymentAmount =
        (session.booking.invoice.amount_due * session.total_price) /
        session.booking.uncancelled_session_total_price
    }
  }

  // If paymentStatus wasn't set then leave the payment-section hidden
  if (paymentStatus) {
    if (paymentAmount) {
      paymentStatus = paymentStatus.toLowerCase()
      document.getElementById(
        "payment-method"
      ).innerHTML = `£${paymentAmount.toFixed(
        2
      )} ${paymentStatus}${paidDate}${invoiceText}`
    } else {
      // If there is no price we need to capitalise the first letter of the paymentStatus
      paymentStatus =
        paymentStatus.charAt(0).toUpperCase() + paymentStatus.slice(1)
      document.getElementById(
        "payment-method"
      ).innerHTML = `${paymentStatus}${paidDate}${invoiceText}`
    }
    document.getElementById("payment-section").classList.remove("hide")

    // Only show Stripe dashboard links to Sharesy team - venues can't access these
    if (isAdmin) {
      let stripeDashboardUrl = null
      if (session.booking.stripe_payment_intent) {
        stripeDashboardUrl =
          "https://dashboard.stripe.com/payments/" +
          session.booking.stripe_payment_intent
      } else if (session.booking.stripe_invoice) {
        stripeDashboardUrl =
          "https://dashboard.stripe.com/invoices/" +
          session.booking.stripe_invoice
      } else if (session.booking.stripe_payment_method) {
        stripeDashboardUrl =
          "https://dashboard.stripe.com/search?query=" +
          session.booking.stripe_payment_method
      }
      if (stripeDashboardUrl) {
        let stripeDashboardLink = document.getElementById(
          "stripe-dashboard-link"
        )
        stripeDashboardLink.href = stripeDashboardUrl
        stripeDashboardLink.classList.remove("hide")
      }
    }
  }

  // We also check if there are additional invoices for the booking resulting
  // from reschedules, and display them in the changes-payment-section.
  let changeInvoices = []
  if (session.session_invoices) {
    for (const invoice of session.session_invoices) {
      let changesPaymentStatus = ""
      let changesPaidDate = ""
      let changesInvoiceText = ""
      if (invoice.status === "overdue") {
        changesPaymentStatus = `<strong>overdue</strong>`
      } else if (invoice.status === "open") {
        changesPaymentStatus = "owed"
      } else if (invoice.status === "paid") {
        changesPaymentStatus = "paid"
      }
      if (invoice.hosted_invoice_url) {
        changesInvoiceText = ` on invoice <a href="${invoice.hosted_invoice_url}" target="blank">${invoice.invoice_num}</a>.`
      } else {
        changesInvoiceText = ` on invoice ${invoice.invoice_num}.`
      }
      if (["open", "overdue"].includes(invoice.status)) {
        if (invoice.due_date) {
          let dueDate = DateTime.fromISO(invoice.due_date).setZone(
            util.TIMEZONE
          )
          changesInvoiceText += ` Due ${dueDate.toFormat("dd LLL yyyy")}.`
        }
        if (invoice.bacs_debit_status) {
          if (invoice.bacs_debit_status === "pending") {
            changesInvoiceText += `<br/>The booker has set up a direct debit, awaiting approval from their bank. If it is approved payment will be attempted within 6 working days.`
          } else if (invoice.bacs_debit_status === "active") {
            changesInvoiceText += `<br/>The booker has set up a direct debit which their bank approved, payment will be attempted within 3 working days.`
          }
        } else if (invoice.last_payment_error_message) {
          changesInvoiceText += `<br/>The last payment attempt`
          if (invoice.last_payment_error_card_brand) {
            changesInvoiceText += ` with ${invoice.last_payment_error_card_brand} ending ${invoice.last_payment_error_card_last4}`
          } else if (invoice.last_payment_error_bacs_debit_last4) {
            changesInvoiceText += ` with direct debit on account ending ${invoice.last_payment_error_bacs_debit_last4}`
          }
          changesInvoiceText += ` failed: <em>${invoice.last_payment_error_message}</em>`
        }
      }
      if (isAdmin) {
        changesInvoiceText += ` (View <a href="https://dashboard.stripe.com/invoices/${invoice.id}" target="_blank">in Stripe</a>)`
      }
      if (changesPaymentStatus) {
        changeInvoices.push(
          `£${invoice.total} ${changesPaymentStatus}${changesPaidDate}${changesInvoiceText}`
        )
      }
    }
  }
  if (changeInvoices.length > 0) {
    document.getElementById("payment-title").innerText =
      "Booker payment for original booking"
    document.getElementById("changes-payment-method").innerHTML =
      changeInvoices.join("<br />")
    document.getElementById("changes-payment-section").classList.remove("hide")
  }
}

function sessionSlideOverUpdates(session, bookingData, isAdmin) {
  if (session.booking) {
    document.getElementById("booking-session-id").innerText =
      session.booking.id + "-" + session.session_id
  } else {
    document.getElementById("booking-session-id").innerText =
      bookingData.booking_id + "-" + session.session_id
  }
  document.getElementById("copy-booking-link").classList.remove("hide")
  document.getElementById("booking-link-copied").classList.add("hide")
  let bookerName = bookingData.first_name + " " + bookingData.last_name
  if (bookingData.recurring_description) {
    bookerName = bookingData.recurring_description + " - " + bookerName
  }

  let purchaseDateTime = DateTime.fromISO(bookingData.purchase_utc).setZone(
    util.TIMEZONE
  )
  document.getElementById("purchase-time").innerText =
    purchaseDateTime.toFormat("dd LLL yyyy, HH:mm")
  let source = bookingData.source
  if (source === "Dashboard") {
    source = "Dashboard booking"
  } else if (source === "Online") {
    source = "Online booking"
  }
  document.getElementById("source").innerText = source
  document.getElementById("booked-on-section").classList.remove("hide")

  document.getElementById("booker-name").innerText = bookerName
  document.getElementById("booker-email").innerText = bookingData.email
  document.getElementById("booker-phone").innerText = bookingData.phone
  document.getElementById("space").innerText = session.space_name
  let startDateTime = DateTime.fromISO(session.event_start_utc).setZone(
    util.TIMEZONE
  )
  let endDateTime = DateTime.fromISO(session.event_end_utc).setZone(
    util.TIMEZONE
  )
  document.getElementById("times").innerText =
    startDateTime.toFormat("ccc dd LLL yyyy HH:mm") +
    " - " +
    endDateTime.toFormat("HH:mm")

  document.getElementById("hire-duration").innerText =
    "Hire - " + util.timeDiffHoursMins(startDateTime, endDateTime)
  document.getElementById("session-price").innerText = "£" + session.price
  document.getElementById("total-price").innerText = "£" + session.total_price
  let statusText = session.status_name
  let modifiedDateTime = DateTime.fromISO(session.modified_utc).setZone(
    util.TIMEZONE
  )
  if (
    modifiedDateTime > purchaseDateTime &&
    session.status_name != "Unconfirmed"
  ) {
    statusText =
      statusText + " (on " + modifiedDateTime.toFormat("dd LLL yyyy, HH:mm")
    if (session.modified_by) {
      statusText += " by " + session.modified_by.toLowerCase()
    }
    statusText += ")"
  }
  document.getElementById("status").innerText = statusText
  if (session.cancel_reason) {
    document.getElementById("status").innerHTML +=
      "<br>Reason given: " + util.escapeHTML(session.cancel_reason.trim())
  }

  document.getElementById("session-slide-over").classList.remove("hide")
}

export function closeSessionSlideOver() {
  document.getElementById("session-slide-over").classList.add("hide")
  document.getElementById("slide-over-container").classList.remove("show")
  document.getElementById("slide-over-container").classList.add("hide")
}

export async function cancelSession(sessionId, isAdmin) {
  let cancelBy = DateTime.fromISO(
    document.getElementById("cancel-button").dataset.cancelBy
  )
  let swalText = null
  if (cancelBy < DateTime.now()) {
    swalText =
      "NOTE: this booking is past the cancellation deadline of " +
      cancelBy.toFormat("ccc, dd LLL yyyy HH:mm") +
      "."
  }
  let cancelType
  if (isAdmin) {
    const { value: cancelTypeReturn } = await Swal.fire({
      title: "Confirm cancellation type",
      text: swalText,
      input: "radio",
      inputOptions: {
        cancel_refund: "Cancel and refund",
        cancel_only: "Just cancel (no refund)",
      },
      confirmButtonText: "Confirm",
      confirmButtonColor: "#1aa979",
      showCancelButton: true,
      cancelButtonText: "Close",
      cancelButtonColor: "#a3a3a3",
      reverseButtons: true,
      customClass: {
        popup: "swal-custom-popup",
        title: "swal-custom-title",
        confirmButton: "swal-custom-button",
        cancelButton: "swal-custom-button",
      },
      inputValidator: (value) => {
        if (!value) {
          return "You need to choose an option"
        }
      },
    })
    cancelType = cancelTypeReturn
  } else {
    const { isConfirmed: cancelConfirmed } = await Swal.fire({
      title: "Are you sure you want to cancel and refund?",
      text: swalText,
      confirmButtonText: "Cancel and refund",
      confirmButtonColor: "#1aa979",
      showCancelButton: true,
      cancelButtonText: "Close",
      cancelButtonColor: "#a3a3a3",
      reverseButtons: true,
      customClass: {
        popup: "swal-custom-popup",
        title: "swal-custom-title",
        confirmButton: "swal-custom-button",
        cancelButton: "swal-custom-button",
      },
    })
    if (cancelConfirmed) {
      cancelType = "cancel_refund"
    }
  }
  if (cancelType) {
    let processRefund = true
    if (cancelType == "cancel_only") {
      processRefund = false
    }
    try {
      const data = await util.api
        .post("cancel-sessions-token", {
          json: {
            token: await utillogin.getClerkToken(),
            session_ids: [sessionId],
            process_refund: processRefund,
          },
          retry: { limit: 0 },
        })
        .json()
      if (data.success) {
        util.logAmplitudeEvent("Session Cancelled", {
          session_id: sessionId,
          refunded: data.refunded,
        })
        if (data.refunded || !processRefund) {
          Swal.fire({
            icon: "success",
            title: "Booking cancelled",
            showConfirmButton: false,
            customClass: {
              popup: "swal-custom-popup",
              title: "swal-custom-title",
            },
            timer: 2000,
          }).then((result) => {
            window.location.reload()
          })
        } else {
          await Swal.fire({
            icon: "error",
            title: "Refund failed",
            text:
              "The booking was cancelled but the refund failed. " + data.reason,
            confirmButtonText: "Reload page",
            confirmButtonColor: "#d31818",
            customClass: {
              popup: "swal-custom-popup",
              title: "swal-custom-title",
              confirmButton: "swal-custom-button",
            },
            allowOutsideClick: false,
          })
          window.location.reload()
        }
      } else {
        await Swal.fire({
          icon: "error",
          title: "Cancellation failed",
          text:
            "Error cancelling session - you may need to try again. " +
            (data.reason ? data.reason : ""),
          confirmButtonText: "OK",
          confirmButtonColor: "#d31818",
          customClass: {
            popup: "swal-custom-popup",
            title: "swal-custom-title",
            confirmButton: "swal-custom-button",
          },
        })
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Cancellation failed",
        text: "Error cancelling session - you may need to try again.",
        confirmButtonText: "OK",
        confirmButtonColor: "#d31818",
        customClass: {
          popup: "swal-custom-popup",
          title: "swal-custom-title",
          confirmButton: "swal-custom-button",
        },
      })
      util.logToSentry(error)
      util.logAmplitudeEvent("Unknown Error Cancelling Session", {
        session_id: sessionId,
      })
    }
  }
}

export function registerSpaceBookingLinkListener(amplitudeEvent) {
  if ("clipboard" in navigator) {
    document.getElementById("copy-space-booking-link").addEventListener(
      "click",
      async function () {
        util.logAmplitudeEvent(amplitudeEvent)
        let copyLink = document.getElementById("copy-space-booking-link")
        await navigator.clipboard.writeText(copyLink.dataset.spaceBookingUrl)
        copyLink.classList.add("hide")
        document
          .getElementById("space-booking-link-copied")
          .classList.remove("hide")
        document
          .getElementById("space-booking-link-explainer")
          .classList.add("hide")
      },
      false
    )
  } else {
    // Don't use the hide class since that will be unhidden
    document.getElementById("space-booking-link-section").style.display = "none"
  }
}
